@import "styles/variables";

.default {
	/*border: 1px solid transparent;*/
}

.focus button {
  box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.25), inset 0 1px 0 var(--color-border-orange-focus), inset 0 -2px 0 var(--color-border-orange-focus);
  transform: translateY(-1px);
}

.button {
	text-align: center;
  position: relative;
}

.button.disabled {
	opacity: 0.5;
	pointer-events: none;
}

.button button {
  color: #000;
  background-color: var(--color-yellow);
  border: none;
  width: 100%;
  padding: 18px;
  cursor: pointer;  
  font-size: var(--font-size-large);
	font-family: var(--font-stack-condensed-bold);
	text-transform: uppercase;
  letter-spacing: 1px;
	-webkit-tap-highlight-color: transparent;
	transition: box-shadow 0.1s ease-out, transform 0.1s ease-out, background-color 0.3s, color 0.3s, width 0.3s, border-width 0.3s, border-color 0.3s;
}

/* Text (transition for when returning to initial state) */
.button button span {
	display: inline-block;
	position: relative;
	-webkit-transition: opacity 0.3s 0.1s;
	transition: opacity 0.3s 0.1s;
}

.default.button {
  background-color: var(--color-yellow);
}

.disabled.button {
  background-color: var(--color-grey)
}
.disabled.button button {
	background-color: var(--color-grey)
}
/*.focus.button {
  background-color: var(--color-border-orange-focus);
}*/

.button img {
	display: none;
}
.loading.button img {
	display: block;
  position: absolute;
  top: 50%;
  right: 20px;	
  transform: translateY(-50%);
}